import { render, staticRenderFns } from "./infoPool.vue?vue&type=template&id=21ca4598&scoped=true"
import script from "./infoPool.vue?vue&type=script&lang=js"
export * from "./infoPool.vue?vue&type=script&lang=js"
import style0 from "./infoPool.vue?vue&type=style&index=0&id=21ca4598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca4598",
  null
  
)

export default component.exports